import { memo } from "react";
import styles from "./RenderSection.module.scss";
import { SectionInstance } from "../../../../../../../model/service-request/section-instance";
import RenderAttribute from "./RenderAttribute/RenderAttribute";

type Props = {
  sectionInstance: SectionInstance;
};

const RenderSection: React.FC<Props> = memo((props: Props) => {
  const sectionInstance = props.sectionInstance;

  return (
    <div className={styles.sectionContainer}>
      <span className={styles.sectionHeader}>{sectionInstance.sectionDefinition.name}</span>
      {sectionInstance.attributeValues.map((av) => (
        <RenderAttribute key={av.id} attributeValue={av} />
      ))}
    </div>
  );
});

export default RenderSection;